"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var uploadOverlay_1 = require("../uploadOverlay");
var surface_1 = require("../surface");
var icon_1 = require("../icon");
var UploadBox = /** @class */ (function (_super) {
    tslib_1.__extends(UploadBox, _super);
    function UploadBox(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onDragLeave = function (e) {
            var onDragLeave = _this.props.onDragLeave;
            _this.setState({
                dragOver: false
            });
            onDragLeave && onDragLeave(e);
        };
        _this.onDragEnter = function (e) {
            var onDragEnter = _this.props.onDragEnter;
            _this.setState({
                dragOver: true
            });
            onDragEnter && onDragEnter(e);
        };
        _this.onDrop = function (e) {
            var onDrop = _this.props.onDrop;
            _this.setState({
                dragOver: false
            });
            onDrop && onDrop(e);
        };
        _this.state = { dragOver: false };
        return _this;
    }
    UploadBox.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, theme = _b.theme, iconName = _b.iconName, text = _b.text, onDragEnter = _b.onDragEnter, onDragLeave = _b.onDragLeave, onDrop = _b.onDrop, others = tslib_1.__rest(_b, ["className", "theme", "iconName", "text", "onDragEnter", "onDragLeave", "onDrop"]);
        var dragOver = this.state.dragOver;
        var classes = classnames_1.default(theme["upload-box"], className, (_a = {},
            _a[theme["drag-over"]] = dragOver,
            _a));
        return (React.createElement(surface_1.Surface, { className: classes },
            React.createElement(uploadOverlay_1.UploadOverlay, tslib_1.__assign({}, others, { onDragEnter: this.onDragEnter, onDragLeave: this.onDragLeave, onDrop: this.onDrop })),
            React.createElement("div", { className: theme.inner },
                iconName ? React.createElement(icon_1.Icon, { iconName: iconName, size: 2.2 }) : null,
                React.createElement("div", { className: theme.text }, text))));
    };
    UploadBox.defaultProps = {
        iconName: "icon-upload",
        text: "Drag & Drop files or Click to browse"
    };
    return UploadBox;
}(React.Component));
exports.default = UploadBox;
